export const asSeenNYTimes = '/images/seen-on/ny-times.png'
export const asSeenAdweek = '/images/seen-on/adweek.png'
export const asSeenCnbc = '/images/seen-on/cnbc.png'
export const asSeenInsider = '/images/seen-on/business-insider.png'
export const asSeenNYPost = '/images/seen-on/ny-post.png'
export const asSeenCheddar = '/images/seen-on/cheddar.png'

export const scanExample = '/images/scan-example.png'

export const posterTemplateIcon = '/images/post-download/poster-icon.png'
export const tableTentTemplateIcon = '/images/post-download/table-tent-icon.png'
export const postCardTemplateIcon = '/images/post-download/post-card-icon.png'

export const cnbc = '/icons/cnbc.svg'

export const brandDontQuit = '/icons/brands-using-flowcode/dontquit.png'
export const brandHulaHut = '/icons/brands-using-flowcode/hulahut.png'
export const brandLordHobo = '/icons/brands-using-flowcode/lordhobo.png'
export const brandPanMass = '/icons/brands-using-flowcode/panmass.png'
export const brandSothebys = '/icons/brands-using-flowcode/sothebys.png'
export const brandWeatherBug = '/icons/brands-using-flowcode/weatherbug.png'
export const curvedBottomRightArrow = '/icons/CurvedBottomRightArrow.svg'

export const alipay = '/static/images/account/alipay.png'
export const bancontact = '/static/images/account/bancontact.png'
export const bank = '/static/images/account/bank.png'
export const blik = '/static/images/account/blik.png'
export const boleto = '/static/images/account/boleto.png'
export const cardAmex = '/static/images/account/amex.png'
export const cardApplePay = '/static/images/account/applepay.png'
export const cardDefault = '/static/images/account/default.svg'
export const cardDiners = '/static/images/account/diners.svg'
export const cardDiscover = '/static/images/account/discover.png'
export const cardGooglePay = '/static/images/account/googlepay.png'
export const cardJcb = '/static/images/account/jcb.png'
export const cardMasterCard = '/static/images/account/mastercard.png'
export const cardUnionPay = '/static/images/account/unionpay.svg'
export const cardVisa = '/static/images/account/visa.png'
export const cashapp = '/static/images/account/cashapp.png'
export const defaultPaymentMethod = '/static/images/account/defaultPaymentMethod.png'
export const eps = '/static/images/account/EPS.png'
export const grabPay = '/static/images/account/grabPay.png'
export const ideal = '/static/images/account/ideal.png'
export const mobilePay = '/static/images/account/mobilePay.png'
export const sepa = '/static/images/account/sepa.png'
export const weChatPay = '/static/images/account/weChatPay.png'

export const carouselChanticleer = '/images/carousel-images/chanticleer.png'
export const carouselHappyPlace = '/images/carousel-images/happy-place-nantucket-pamphlet.png'
export const carouselHappyPlacePhone = '/images/carousel-images/happy-place-nantucket-phone.png'
export const carouselLordHobo = '/images/carousel-images/lord-hobo.png'
export const carouselMakiKosaka = '/images/carousel-images/maki-kosaka.png'
export const carouselOath = '/images/carousel-images/oath.png'
export const carouselPlanner = '/images/carousel-images/planner.png'
export const carouselPizzaSecret = '/images/carousel-images/pizza-secret.png'
export const carouselPride = '/images/carousel-images/pride.png'
export const carouselRindleWaves = '/images/carousel-images/rindle-waves.png'
export const carouselTheBeet = '/images/carousel-images/the-beet.png'
export const carouselTwell = '/images/carousel-images/twell.png'
export const checkmarkFlowBlue = '/icons/checkmark-flow-blue.svg'

export const flowcodeGeneric = '/static/images/flowcodes/code-generic.png'
export const flowcodePreviewAndes = '/images/homepage-flowcode-andes.png'
export const flowcodePreviewCustomizeBanner = '/graphics/customize-codes-banner.png'
export const flowcodePreviewEmail = '/images/homepage-flowcode-email.png'
export const flowcodePreviewFaces = '/images/homepage-flowcode-faces.png'
export const flowcodePreviewVenmo = '/images/homepage-flowcode-venmo.png'
export const flowpageLogo = '/icons/flowpage-logo-black.svg'

export const globeOutline = '/icons/globe-outline.svg'
export const googleLogo = '/logos/google.svg'

export const socialRindleWaves = '/images/rindle-waves-field-image.png'
export const socialRindleWavesFlowcode = '/static/images/flowcodes/rindle-waves-flowcode.png'
export const socialSandBar = '/images/sandbar-field-image-2.png'
export const socialSandBarFlowcode = '/static/images/flowcodes/sandbar-flowcode.png'
export const socialTwell = '/images/twell-field-image.png'
export const socialTwellFlowcode = '/static/images/flowcodes/twell-flowcode.png'

export const templateCodeIcon = '/icons/code-template-icon.png'
export const templatePoster = '/images/poster-template.png'
export const templatePosterIcon = '/icons/poster-template-icon.png'
export const templatePostcard = '/images/postcard-template.png'
export const templatePostcardIcon = '/icons/postcard-template-icon.png'
export const templateSticker = '/images/sticker-template.png'
export const templateStickerIcon = '/icons/sticker-template-icon.png'
export const templateTent = '/images/tent-5-by-7-template.png'
export const templateTentIcon = '/icons/table-tent-template-icon.png'

export const amexBanner = '/images/amex-banner.svg'

export const flowcodeGeneral = '/icons/product/flowcode-general.svg'

// Print store.
export const printProductItemFallback = '/graphics/print-store/product-fallback.svg'
export const printStoreEntryBackground = '/images/edit-template-page-print-store-entry.jpg'
export const printStoreGenericCircleStickers = '/graphics/print-store/generic_circle_stickers.svg'
export const printStoreGenericWallSticker = '/graphics/print-store/generic_wall_sticker.svg'
export const printStoreGenericFloorSticker = '/graphics/print-store/generic_floor_sticker.svg'
export const printStepsHorizontal = '/images/print-store/flowcode-sticker-steps-horizontal.png'
export const printStepsVertical = '/images/print-store/flowcode-sticker-steps-vertical.png'
export const printStepsHorizontalStep1 = '/images/print-store/flowcode-sticker-step1-horizontal.svg'
export const printStepsHorizontalStep2 = '/images/print-store/flowcode-sticker-step2-horizontal.svg'
export const printStepsHorizontalStep3 = '/images/print-store/flowcode-sticker-step3-horizontal.svg'
export const printCalloutBusinessCards =
  '/images/print-store/print-store-callout-business-card.jpeg'
export const printCalloutCoasters = '/images/print-store/print-store-callout-coasters.jpeg'
export const printCalloutStickers = '/images/print-store/print-store-callout-stickers.jpeg'
export const printCalloutTableTents = '/images/print-store/print-store-callout-table-tent.jpeg'

export const circlePlusOutline = '/icons/circle-plus-outline.svg'
export const circlePlusOutlineWhite = '/icons/circle-plus-outline-white.svg'
export const underConstructionIcon = '/icons/under-construction.svg'
export const flowcodeRectangleLogoBlack = '/icons/flowcode-small-black.svg'

export const scanToOwnGenericLandingBackground = '/images/ScanToOwn/LandingBackground.png'
export const scanToOwnGenericWebsiteFormBanner = '/images/ScanToOwn/WebsiteFormBanner.png'
export const scanToOwnGenericTextMsgFormBanner = '/images/ScanToOwn/TextMsgFormBanner.png'
export const scanToOwnGenericEmailFormBanner = '/images/ScanToOwn/EmailFormBanner.png'
export const scanToOwnGenericSocialFormBanner = '/images/ScanToOwn/SocialFormBanner.png'
export const scanToOwnGenericGoogleDocFormBanner = '/images/ScanToOwn/GoogleDocFormBanner.png'
export const scanToOwnGenericFileFormBanner = '/images/ScanToOwn/FileFormBanner.png'
export const scanToOwnGenericYoutubeFormBanner = '/images/ScanToOwn/YoutubeFormBanner.png'
export const scanToOwnGenericPhoneNumberFormBanner = '/images/ScanToOwn/PhoneNumberFormBanner.png'
export const scanToOwnGenericVenmoFormBanner = '/images/ScanToOwn/VenmoFormBanner.png'
export const scanToOwnGenericFlowpagePreview = '/images/ScanToOwn/FlowpagePreview.png'

export const qr = '/icons/Qr.svg'
export const pageOutlined = '/icons/PageOutlined.svg'
export const sitckerOutlined = '/icons/StickerOutlined.svg'
export const dataHorizontalBarOutlined = '/icons/DataHorizontalBar.svg'
export const errorFlowcode = '/static/images/flowcodes/ErrorFlowcode.png'
export const errorFlowcodeBlack = '/static/images/flowcodes/ErrorFlowcodeBlack.png'

export const smartLinksIcon = '/icons/smart-links.svg'
export const myFlowpagesIconFilledBlack = '/icons/my-flowpages-filled-black.svg'
export const lightningBoltIconFilled = '/icons/lightning-bolt-filled.svg'
export const lockIconBlackBackground = '/icons/lock-black-background.svg'
